import React, { useEffect, useState } from 'react'
import { Flex, Input, Space, Table, Modal, Form, Button} from 'antd';
import { useGetyonghuListQuery } from '../../store/dianshangtaizhangApi';
import FirmUserEdit from './FirmUserEdit';
import FirmUserAdd from './FirmUserAdd';
import { TeamOutlined } from '@ant-design/icons';
function FirmUserList(props) {
    const [form] = Form.useForm();
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);    
    const [query, setQuery] = useState({
            yh_qy_id: props.qy_id,
            yh_phone: '',
            yh_name: '',
    });

    const {data, isSuccess} = useGetyonghuListQuery(query, {refetchOnMountOrArgChange: true});
    
    useEffect(() => {
        if (isSuccess && data) {
            setList(data.Result);
        }
    }, [data, isSuccess]);
    
    const columns = [        
            {
                key: 'yh_name',
                title: '姓名',            
                dataIndex: 'yh_name',
            },      
            {
                key: 'yh_phone',
                title: '手机号码',            
                dataIndex: 'yh_phone',
            },                    
            {
                key: 'yh_state',
                title: '状态',            
                dataIndex: 'yh_state',
                render: (_, record) => {
                    if(record.yh_state === '1'){
                    return <span style={{color:'green'}}>正常</span>;
                    }else if(record.yh_state === '0'){
                    return <span style={{color:'red'}}>禁用</span>;
                    }
                    return null;
                }
            },
            {
                key: 'yh_juese',
                title: '角色',            
                dataIndex: 'yh_juese',                
            },
            {
                key: 'yh_qx',
                title: '权限',            
                dataIndex: 'yh_qx',
            },
            {
                key: 'num',
                title: '编号',            
                dataIndex: 'yh_id',
            },    
            {
                key: 'yh_uname',
                title: '操作时间',            
                dataIndex: 'yh_uname',
                render:(_,record) => {
                    return <span>{record.yh_ctime + record.yh_uname}</span>;
                }
            },   
            {
                key: 'action',
                title: '操作',
                render: (_, record) => {
                    return (
                    <Space>
                        <FirmUserEdit yh_id={record.yh_id} yh_name={record.yh_name} eu_id={eu_id} eu_name={eu_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
                    </Space>
                    );
                }
            },
    ];   
  
  return (
    <>
        <a onClick={() => {setOpen(true)}}><TeamOutlined /> 操作员</a>
        <Modal
            open={open}
            onCancel={() => {setOpen(false)}}
            title={`操作员列表(${props.qy_name})`}
            width={1200}
            footer={null}
        >
            <Flex justify='space-between'>
                <Form
                    form={form}
                    layout="inline"
                    name="form_client"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 6 }}                                  
                >
                    <Form.Item label='姓名' name='yh_name'>
                        <Input onChange={(e) => {
                            setQuery(prevState => ({...prevState, yh_name: e.target.value}));
                        }} />
                    </Form.Item>
                    <Form.Item label='手机号码' name='yh_phone'>
                        <Input onChange={(e) => {
                            setQuery(prevState => ({...prevState, yh_phone: e.target.value}));
                        }} />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                        <Button onClick={() => {
                            form.submit();
                        }}>查询</Button>
                        <Button onClick={() => {
                            form.resetFields();
                            setQuery(prevState => ({...prevState, yh_name: '', yh_phone: ''}));
                        }}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
                <FirmUserAdd eu_id={eu_id} eu_name={eu_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                showSizeChanger: true,
                defaultPageSize: 50,
                showTotal: (total) => `共${total}条`,
                }} 
                style={{marginTop:'10px'}}
                rowKey='yh_id'
            />
        </Modal>
    </>
  );
}

export default FirmUserList;